import GoogleDrivePickers from "../../../../../components/ThirdPartyServices/GoogleDrivePickers";
import DropboxChooser from "../../../../../components/ThirdPartyServices/DropboxChooser";
import googleDrive from "../../../../Onboarding/components/assets/googleDrive.svg";
import dropBox from "../../../../Onboarding/components/assets/dropBox.svg";
import Upload from "../../../../Onboarding/components/assets/Upload.svg";
import { useState } from "react";
import { useUsersContext } from "../../../../../context/usersContext";

const UploadMethods = ({ setFile, loading, setLoading }) => {
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const { contextUploadFileOnboarding } = useUsersContext();

  const filesFromThirdParty = async (files) => {
    setLoading({ ...loading, uploadFile: true });
    const uploadRes = await contextUploadFileOnboarding(
      files,
      "",
      setSpinnerLoading
    );
    if (!uploadRes?.data?.success) return;

    const file_ids = uploadRes.data.data.map((obj) => obj.name);

    setFile(file_ids);
    setLoading({ ...loading, uploadFile: false });
  };

  const gettingfilefromdropzone = async (files) => {
    setLoading({ ...loading, uploadFile: true });
    const responseOld = await contextUploadFileOnboarding(
      files,
      "",
      setSpinnerLoading
    );
    // if (!responseOld) return setLoading(false);
    try {
      const file_ids = responseOld.data.data.map((obj) => obj.name);
      if (file_ids.length > 0) {
        setDisabled(true);
      }
      setFile(file_ids);
      setLoading({ ...loading, uploadFile: false });
    } catch (err) {
      alert(err.message);
      setLoading({ ...loading, uploadFile: false });
      console.log(err);
    }
  };

  return (
    <>
      <p className="text-muted-foreground mt-4 mb-2 text-md">Add a New File</p>
      <div
        onClick={() => {
          console.log("Google Drive clicked");
        }}
        className="border shadow mb-[10px] cursor-pointer gap-3 !border-border h-[45px] flex items-center justify-center rounded-md"
      >
        <img src={googleDrive} alt={"Connect to Google Drive"} />
        <GoogleDrivePickers
          disabled={disabled}
          files_send_to_parent={filesFromThirdParty}
          setSpinnerLoading={setSpinnerLoading}
        />
      </div>

      <div
        onClick={() => {
          console.log("Google Drive clicked");
        }}
        className="relative border shadow mb-[10px] gap-3 cursor-pointer !border-border h-[45px] flex items-center justify-center rounded-md"
      >
        <img src={dropBox} alt={"Connect to Dropbox"} />
        <DropboxChooser
          disabled={disabled}
          files_send_to_parent={filesFromThirdParty}
          setSpinnerLoading={setSpinnerLoading}
        />
      </div>
      <label
        htmlFor="upload"
        className="border shadow mb-[10px] gap-3 cursor-pointer !border-border h-[45px] flex items-center justify-center rounded-md"
      >
        <img src={Upload} alt={"Upload from Computer"} />
        <span className="text-md">Upload from Computer</span>
      </label>
      <input
        type="file"
        id="upload"
        hidden
        onChange={(e) => gettingfilefromdropzone(e.target.files)}
      />
    </>
  );
};

export default UploadMethods;
